module.exports = __webpack_public_path__ + "media/icons/upload-route-icon-a02269d5.svg";